import type BaseEntity from "./base-entity";
import {Country} from "currency-codes-ts/dist/types";

export default interface Plant extends BaseEntity {
  name: string;
  region: PlantRegion;
  country: Country;
  technologies: string[];

  managers: string[];
  roles?: Record<string, string[]>;
}

export enum PlantRegion {
  WesternEurope = "Western Europe",
  EasternEurope = "Eastern Europe",
  MiddleEast = "Middle East",
  Asia = "Asia",
  Japan = "Japan",
  NorthAmerica = "North America",
  LatinAmerica = "Latin America"
}
